import api from '@/utils/api';

/**
 * Get  supplier's products by a selected product category
 * @param {string} id - the product id
 * @param {string} options - the option selection
 * @returns {Promise}
 */
const getSupplierUEImageApi = (id, options) => {
  const url = `/unreal-engine/${id}`;
  return api.post(url, options);
};

export default getSupplierUEImageApi;
